import type { Role } from "@esi/shared";
import { createContext, useContext } from "react";

/** The signed-in user, as the SPA needs it; the tenant stays on the server. */
export interface Session {
  csrfToken: string;
  userId: string;
  /** The entity the user acts in (the session's principal). */
  entityId: string;
  /** Presentation only (the Backoffice entry): the API enforces every permission itself. */
  roles: readonly Role[];
}

const SessionContext = createContext<Session | null>(null);

export const SessionProvider = SessionContext.Provider;

export function useSession(): Session {
  const session = useContext(SessionContext);
  if (!session) {
    throw new Error("useSession outside a signed-in view");
  }
  return session;
}

/** The session when signed in, else null (views also rendered outside a signed-in shell). */
export const useOptionalSession = (): Session | null => useContext(SessionContext);

export const isAdmin = (roles: readonly Role[]) =>
  roles.includes("tenant_admin") || roles.includes("entity_admin");
